import React from "react";
import classes from "./InfoPasswordLabels.module.scss";
import { useTranslation } from "react-i18next";
import InfoLabel from "../InfoLabel";

const InfosPasswordLabels = ({
  hasNumber = false,
  hasMinEight = false,
  hasUppercase = false,
  hasLowercase = false,
}) => {
  const { t } = useTranslation();
  let hasNumberClass = hasNumber ? classes.Green : classes.Red;
  let hasMinEightClass = hasMinEight ? classes.Green : classes.Red;
  let hasUppercaseClass = hasUppercase ? classes.Green : classes.Red;
  let hasLowercaseClass = hasLowercase ? classes.Green : classes.Red;

  return (
    <>
      <InfoLabel
        className={"col-12"}
        bold
        text={t("global.passwords_must_contain")}
      />
      <InfoLabel
        className={hasNumberClass + " col-12"}
        text={"- " + t("global.at_least_one_number")}
      />
      <InfoLabel
        className={hasMinEightClass + " col-12"}
        text={"- " + t("global.at_least_8_digits")}
      />
      <InfoLabel
        className={hasUppercaseClass + " col-12"}
        text={"- " + t("global.at_least_one_capital_letter")}
      />
      <InfoLabel
        className={hasLowercaseClass + " col-12"}
        text={"- " + t("global.at_least_one_lowercase_letter")}
      />
    </>
  );
};

export default InfosPasswordLabels;
